// A sensor, opened, on the desktop shell — the counterpart to the mobile
// screen of the same name, and driven by the same core parser so the two can
// never disagree about what green means.
//
// It replaces UnsupportedScreen for these devices, which built toggles from the
// device's outputs and, finding none, said "No controllable outputs found." to
// the owner of a working door sensor.

import React from 'react';
import { Box, Typography } from '@mui/material';
import DeviceShell from '../../components/DeviceShell';
import { useDeviceStatus } from '../../../../core/mqtt/useDeviceStatus';
import {
  sensorStateOf, SENSOR_ALERT, SENSOR_NORMAL,
} from '../../../../core/devices/sensorState';

const COLOURS = {
  [SENSOR_NORMAL]: '#2E7D32',
  [SENSOR_ALERT]: '#C62828',
};
const NEUTRAL = '#9E9E9E';

export default function SensorScreen({ device, initialStatus = '' }) {
  const uno = device.UniqueNumber;
  const [status, , liveAt] = useDeviceStatus(uno, initialStatus || device.Status || '');
  const { state, label } = sensorStateOf(status, device.DeviceID);
  const colour = COLOURS[state] || NEUTRAL;

  return (
    <DeviceShell title={device.DeviceName || uno}>
      <Box sx={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, py: 4,
      }}
      >
        <Box sx={{
          width: 140,
          height: 140,
          borderRadius: '50%',
          bgcolor: colour,
          boxShadow: `0 0 0 12px ${colour}1F`,
        }}
        />
        <Typography variant="h5" fontWeight={700} sx={{ color: colour, textTransform: 'uppercase' }}>
          {label}
        </Typography>
        {/* `liveAt`, not `status` — the seed is the server's last-known value
            and says nothing about whether the device is there. */}
        <Typography variant="caption" color="text.secondary">
          {liveAt ? 'Live' : 'Last known state'}
        </Typography>
      </Box>
    </DeviceShell>
  );
}
